import { render, staticRenderFns } from "./FilesModal.vue?vue&type=template&id=561e6094&"
import script from "./FilesModal.vue?vue&type=script&lang=ts&"
export * from "./FilesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports